import { useState } from 'react'
import { BoardPage } from './pages/BoardPage'
import { PairPage } from './pages/PairPage'
import { clearToken, readToken } from './lib/screen-token'
import { trackerApi } from './api/client'

/**
 * Два состояния: экран не привязан (окно запроса авторизации) или показывает доску.
 * Роутера нет — переключение состоянием, как в остальных мини-приложениях.
 */
export function App(): React.JSX.Element {
  const [token, setToken] = useState<string | null>(readToken())
  /** Почему просим код: отзыв, выключение экрана или просто нет токена. */
  const [reason, setReason] = useState<string | null>(null)

  if (!token) {
    return (
      <PairPage
        reason={reason}
        onPaired={() => {
          setReason(null)
          setToken(readToken())
        }}
      />
    )
  }

  return (
    <>
      <BoardPage
        onUnauthorized={(why) => {
          // Доступ закрыт («Новый код», экран выключен или удалён) — стираем токен
          // и честно говорим, что случилось, вместо пустой доски.
          clearToken()
          setReason(why)
          setToken(null)
        }}
      />
      <div className="foot">
        <button
          onClick={() => {
            void trackerApi.unpair().catch(() => undefined)
            clearToken()
            setReason(null)
            setToken(null)
          }}
        >
          Отвязать экран
        </button>
      </div>
    </>
  )
}
